import { render, staticRenderFns } from "./StaffDetail.vue?vue&type=template&id=02817a28&scoped=true"
import script from "./StaffDetail.vue?vue&type=script&lang=js"
export * from "./StaffDetail.vue?vue&type=script&lang=js"
import style0 from "./StaffDetail.vue?vue&type=style&index=0&id=02817a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02817a28",
  null
  
)

export default component.exports